import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { 
  TrophyOutlined,
  DollarOutlined,
  VideoCameraOutlined,
  HomeOutlined,
  BarChartOutlined,
  TeamOutlined,
  AlignLeftOutlined
} from '@ant-design/icons';
import './About.css';

import about1 from '../assets/image/about/IMG_4877.PNG';
import about2 from '../assets/image/about/IMG_4878.PNG';
import about3 from '../assets/image/about/IMG_4879.PNG';
import about4 from '../assets/image/about/IMG_4880.PNG';
import about5 from '../assets/image/about/IMG_4881.PNG';


const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const About = () => {
  return (
    <Content className="top-color"style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* <Title level={1} className="about-title">WHO AM I?</Title> */}

      <div className="about-photo-row">
  {[about1, about2, about3, about4, about5].map((img, index) => (
    <img
      key={index}
      src={img}
      alt={`Klyssa ${index + 1}`}
      className="about-photo"
    />
  ))}
</div>
      <Title level={2} className="section-title">About Me</Title>
      <div className="tagline-container">
        <Text className="tagline">🎯 Finance-Trained.</Text>
        <Text className="tagline">🎤 Media-Savvy.</Text>
        <Text className="tagline">💼 Results-Driven.</Text>
      </div>
      
      <Paragraph className="intro-text">
       I bring a powerful blend of finance expertise, media presence, and strategic execution to the real estate world. </Paragraph>

      <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
        <Col xs={24} md={12}>
          <Card 
            title={
              <span className="card-title">
                <DollarOutlined /> Finance as a Foundation
              </span>
            }
            className="about-card"
          >
            <Paragraph>
              Before real estate, I built my career in the financial services industry—specialising in private equity, hedge fund management, and investment strategy. This background allows me to offer more than just transactional support—I bring a strategic lens to asset progression, portfolio planning, and long-term wealth building.
            </Paragraph>
            <Paragraph>
              With close to 6 years of sales experience across the Financial and Tech SaaS industries, I’ve refined my craft in both B2C and B2B environments—making me a highly versatile and dynamic advisor.
            </Paragraph>
            <Paragraph>
              My strong foundation in sales has shaped a relentless, never-give-up attitude, a deep understanding of what clients truly want, and the ability to communicate value with clarity and conviction. Whether it’s positioning a home or negotiating a deal, I pride myself on showcasing what makes a property worth the price—and delivering service that goes above and beyond.
            </Paragraph>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card 
            title={
              <span className="card-title">
                <VideoCameraOutlined /> Storytelling is My Edge
              </span>
            }
            className="about-card"
          >
            <Paragraph className='experience-list'>
              With a background in media, pageantry, and live presentation, I know how to make 
              homes shine beyond just specs and square footage. My experience includes:
            </Paragraph>
            <ul className="experience-list">
              <li>Finalist in Miss Global Singapore</li>
              <li>Professional host, emcee, and presenter for corporate events</li>
              <li>Engaged by Singapore's well-known Retail Brands to conduct LiveStreams and TikTok</li>
              <li>Shared the stage with notable personalities like Benjamin Kheng</li>
              <li>Appointed by PropNex HQ to front official video content and campaigns</li>
              <li>Personally scripted and personalised storyboards for every property tour</li>
              <li>Generated over 5 million views across platforms</li>
            </ul>
            <Paragraph className='experience-list'>
              This unique storytelling approach creates real traction, visibility, and buyer engagement—helping 
              clients' listings stand out in a crowded market.
            </Paragraph>
          </Card>
        </Col>
      </Row>

      <Card 
        title={
          <span className="card-title">
            <TrophyOutlined /> Track Record of Excellence
          </span>
        }
        className="achievements-card"
        style={{ marginTop: '24px' }}
      >
        <Paragraph>
          I am a Top 1% Achiever in PropNex Gen—a testament to consistency, 
          skill, and results. My achievements at PropNex include:
        </Paragraph>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <div className="achievement-item">
              <Text strong>🥇 PropNex Gen Top 1% Achiever</Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <div className="achievement-item">
              <Text strong>👩‍💼 PropNex Gen Committee Member</Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <div className="achievement-item">
              <Text strong>🏅 Multiple-time Super Gold Achiever</Text>
            </div>
          </Col>
         
        </Row>
      </Card>

      <Card 
        title={
          <span className="card-title">
            <TeamOutlined /> Accolades & Achievements
          </span>
        }
        className="about-card"
        style={{ marginTop: '24px' }}
      >
        <ul className="accolades-list">
      <li>Top 1% Producers under 35, PropNex Gen</li>
      <li>Top 4% Producers among 13,000+ PropNex agents (Q3-4 2025)</li>
      <li>Top 8% Producers among 13,000+ PropNex agents (Q1-2 2025)</li>
      <li>Top Transactor – Jan 2025 (Top 2% Monthly Ranking)</li>
      <li>9th Position – PropNex Top Achievers</li>
      <li>SuperGold Achiever – Jan 2025, June 2025</li>
      <li>Consistent Gold Achievers for 2023, 2024, and 2025</li>
      
       </ul>
        <Paragraph strong>
          "Every home has a story—let me help you tell yours with impact."
        </Paragraph>
      </Card>

      <Card 
        title={
          <span className="card-title">
            <HomeOutlined /> Full-Spectrum Real Estate Services
          </span>
        }
        className="services-card"
        style={{ marginTop: '24px' }}
      >
        <Paragraph>
          Whether you're buying, selling, leasing, or investing, I provide end-to-end guidance 
          grounded in expertise, data, and service excellence.
        </Paragraph>
        <Title level={4} style={{ marginTop: '16px' }}>My areas of focus include:</Title>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><BarChartOutlined /> Residential</Title>
              <Text>HDB, condominiums, and landed homes (My core speciality)</Text>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><DollarOutlined /> Commercial</Title>
              <Text>Shophouses and office spaces</Text>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><TeamOutlined /> Advisory</Title>
              <Text>Asset progression & investment strategy</Text>
            </Card>
          </Col>
        </Row>
      </Card>
    </Content>
  );
};

export default About;